import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "gamma",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:f4a295cc-8b01-49b7-bc97-bdc46cd9550a",
    aws_user_pools_id: "ap-southeast-2_D2IFHvCQW",
    aws_user_pools_web_client_id: "6nig5372n11fiie80us8g89c2u",
    Auth: {
      identityPoolId: "ap-southeast-2:f4a295cc-8b01-49b7-bc97-bdc46cd9550a",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_D2IFHvCQW",
      userPoolWebClientId: "6nig5372n11fiie80us8g89c2u",
    },
    oauth: {
      domain: "whs-safer-gamma-in.auth.ap-southeast-2.amazoncognito.com",
      redirectSignIn: "https://gamma.in.safer.whs.amazon.dev",
      redirectSignOut: "https://gamma.in.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };

  // BETA/LOCAL ONLY: the Hydra/Cypress integration test authenticates as a SAAM
  // service identity (svc-mw-...-midwaysaam) that has NO email. The identity
  // pool's authenticated role (AmazonQBusinessCognitoRole) requires an `Email`
  // session tag mapped from the token's `email` claim; with no email, the role
  // assume fails ("Invalid identity pool configuration") and Amplify emits
  // signIn_failure so the app never authenticates. The frontend does not use
  // identity-pool (IAM) credentials, so we drop the identity pool on beta/local
  // and let sign-in complete on the User Pool alone. Gamma/prod are unchanged.
  // Local/dev builds resolve gamma to "test".
  const stage = "gamma".toLowerCase();
  const skipIdentityPool = stage === "beta" || stage === "test";

  if (skipIdentityPool) {
    delete (config as { aws_cognito_identity_pool_id?: string })
      .aws_cognito_identity_pool_id;
    delete (config.Auth as { identityPoolId?: string }).identityPoolId;
  }

  Auth.configure(config);
}
